<template>
    <div :class="route.name == 'dashboard' ? '' : 'appMain'" :data-route="route.name">
        <router-view v-slot="{ Component, route }">
            <transition name="fade">
                <div v-if="route.path !== '/dashboard'" class="box">
                    <el-row
                        class="one_box"
                        :data-route="route.name"
                        v-if="
                            route.path !== '/index' && !isBreadCrumb && route.path !== '/dashboard'
                        "
                    >
                        <div class="breaBox">
                            <el-icon>
                                <EditPen />
                            </el-icon>
                        </div>
                        <Breadcrumb></Breadcrumb>
                    </el-row>
                    <!--      include="TalkScriptView"     -->
                    <KeepAlive>
                        <component :is="Component" v-if="route.meta.keepAlive" />
                    </KeepAlive>
                    <component :is="Component" v-if="!route.meta.keepAlive" />
                </div>

                <component v-else :is="Component" />
            </transition>
        </router-view>
    </div>
</template>

<script setup name="appMain">
import Breadcrumb from '@/components/Breadcrumb'
import { useRoute } from 'vue-router'
import { useIndexSore } from '@/store/modules/app'
import { storeToRefs } from 'pinia'

const store = useIndexSore()
const { isBreadCrumb, styleHeight } = storeToRefs(store)
const route = useRoute()
</script>

<style lang="scss" scoped>
.appMain {
    background-color: #fff;

    &[data-route='AgentMonitoring'],
    &[data-route='taskManage'],
    &[data-route='tasks'],
    &[data-route='dissingClues'],
    &[data-route='dataTwo'] {
        height: 100%;
    }
}

.fade-enter-from,
.fade-leave-to {
    transform: translateX(20px);
    opacity: 0;
}

.fade-leave-active {
    transition: all 0.5s ease;
}

.fade-enter-to,
.fade-leave-from {
    opacity: 1;
}

.fade-enter-active {
    transition: all 1s ease;
}

.box {
    background-color: #fff;
    border-radius: 15px;
    display: flex;
    flex-direction: column;
    padding: 10px 25px;
    box-sizing: border-box;
    height: inherit;

    .one_box {
        // background-color: rgb(243, 243, 243);
        border-bottom: 1px solid #eee;
        height: 60px;
        line-height: 50px;
        text-align: left;
        border-radius: 4px;
        margin-bottom: 15px;
        padding-left: 15px;
        display: flex;
        align-items: center;

        &[data-route='talkscripts'] {
            display: none;
        }

        .breaBox {
            height: 100%;
            display: flex;
            align-items: center;
            margin-right: 10px;
        }
    }
}
</style>
